import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'

// Vuex Modules to load
const UserRulesStoreModule = () => import(/* webpackChunkName: "Rules" */ '../store/modules/userRules')
const UserRuleStoreModule = () => import(/* webpackChunkName: "Rules" */ '../store/modules/userRule')

// Components to load
const Rules = () => import(/* webpackChunkName: "Rules" */ '@/components/rules/Rules')
const RulesList = () => import(/* webpackChunkName: "Rules" */ '@/components/rules/RulesList')
const UpsertRule = () => import(/* webpackChunkName: "Rules" */ '@/components/rules/UpsertRule')

// ******************************************************
// *************** Route Guard Functions ****************
// ******************************************************

const dynamicModuleRegistrationRulesArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'userRules',
    module: UserRulesStoreModule,
    store,
    modulePath: 'userRules'
  }
}
const dynamicModuleRegistrationRuleArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'userRule',
    module: UserRuleStoreModule,
    store,
    modulePath: 'userRule'
  }
}

// ******************************************************
// ****************** Route Definitions *****************
// ******************************************************

export default [
  {
    path: '/Rules',
    component: Rules,
    beforeEnter (to, from, next) {
      Promise.all([
        DynamicModuleRegistrationUtil(dynamicModuleRegistrationRulesArgs()),
        DynamicModuleRegistrationUtil(dynamicModuleRegistrationRuleArgs())
      ]).then(() => next())
    },
    children: [
      {
        path: '/',
        name: 'RulesList',
        component: RulesList
      },
      {
        path: 'CreateRule',
        alias: 'EditRule',
        name: 'UpsertRule',
        component: UpsertRule
      }
    ]
  }
]
